import { Body, Classes, Link } from '@pinpointhq/thumbtack';
import * as classNames from 'classnames';
import { isString } from 'lodash';
import * as React from 'react';
import { isWebUri } from 'valid-url';

export interface ITabularListProps {
  items: { value?: React.ReactNode; label: string }[];
}

export function TabularList(props: ITabularListProps) {
  const { items } = props;
  const classes = classNames(Classes.LIST_TABULAR, 'mar-t-2');

  return (
    <ul className={classes}>
      {items.map(({ value, label }, index) => {
        if (!value) return null;

        let content: React.ReactNode = value;

        if (isString(value) && isWebUri(value)) {
          content = (
            <Link href={value} target="_blank" style={{ wordBreak: 'break-all' }}>
              {value}
            </Link>
          );
        }

        return (
          <li key={String([index, label])}>
            <Body>{label}</Body>
            <Body style={{ wordBreak: 'break-word' }}>{content}</Body>
          </li>
        );
      })}
    </ul>
  );
}
